import { DEDICATED_COMMON_PARAMS } from 'common/constants/app.constants';
import { getCommercialAttributesList } from 'common/helper/api.helper';
import PlanConfigurationForMPLS from 'dedicated/components/choose-plan/planConfigurationForMPLS';
import { serviceOptions, SERVICES_ENUM } from 'home/common/constants/constants';
import React, { useEffect, useState } from 'react';
import { fetchPlans } from '../../../../common/helper/api.helper';
import { getFromSessionStorage, setInSessionStorage } from '../../../../common/utils/app.utils';
import { AVAILABLE_BANDWIDTH, MODULE_ID } from '../../../../home/common/constants/constants';
import PlanConfigrationModal from '../../choose-plan/planConfigrationModal';
import { checkLeadSatus } from '../configure-plan-pricing-constant';

const ViewAvailableConfiguration = ({ open, setOpen, commercialAttribute, partyId }) => {
  const [ipAttributeType, setIpAttributeType] = useState(false);
  const [isBandwidthAvailable, setIsBandwidthAvailable] = useState(false);
  const fetchBandwidth = () => {
    const payload = { maxBandwidth: 1000, partyId: partyId, pincode: '122001', service: SERVICES_ENUM.MANAGED };
    fetchPlans(payload, true)
      .then((response) => {
        let data = response && response.data;
        setInSessionStorage(MODULE_ID, AVAILABLE_BANDWIDTH, data.result);
        setIsBandwidthAvailable(true);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    const bandwidths = getFromSessionStorage(MODULE_ID, AVAILABLE_BANDWIDTH);
    if (!bandwidths && DEDICATED_COMMON_PARAMS.serviceType === 'VPN') {
      fetchBandwidth();
    } else {
      setIsBandwidthAvailable(true);
    }
  }, []);
  return (
    <React.Fragment>
      {commercialAttribute && Object.keys(commercialAttribute).length > 0 && DEDICATED_COMMON_PARAMS.serviceType === 'VPN' ? (
        <React.Fragment>
          {isBandwidthAvailable && (
            <PlanConfigurationForMPLS
              open={open}
              close={setOpen}
              commercialAttributes={commercialAttribute}
              updateDiConnectionData={() => {}}
              setIpAttributeType={setIpAttributeType}
              setservicetype={() => {}}
              ipAttributeType={ipAttributeType}
              checkLeadSatus={checkLeadSatus}
              selectedPlan={{ speed: 10, service: SERVICES_ENUM.MANAGED }}
              showOnlyOK={true}
              changeIpAttributeType={() => {}}
            ></PlanConfigurationForMPLS>
          )}
        </React.Fragment>
      ) : (
        <PlanConfigrationModal
          planConfigrationOpen={open}
          setPlanConfigrationOpen={setOpen}
          serviceOptions={serviceOptions}
          selectedserviceOption={serviceOptions[0]}
          onServiceChange={() => {}}
          servicetype={SERVICES_ENUM.MANAGED}
          commercialAttribute={commercialAttribute}
          checkLeadSatus={checkLeadSatus}
          setIpAttributeType={setIpAttributeType}
          updateDiConnectionData={() => {}}
          showOnlyOK={true}
          showRouterSpecs={true}
        />
      )}
    </React.Fragment>
  );
};

export default ViewAvailableConfiguration;
